import * as Yup from "yup";

const CategorySchema = Yup.object().shape({
  title: Yup.string().required("Please enter a title").strict().trim(),
  display_order: Yup.string(),
  image: Yup.string(),
  status: Yup.string().oneOf(["active", "inactive"]).default("active"),
  slug: Yup.string(),
});

export default CategorySchema;
